import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { isMobile } from 'react-device-detect';
import TasklyPreview from './RecentWork/TasklyPreview';
import AbcPreview from './RecentWork/AbcPreview';
import KaenguruPreview from './RecentWork/KaenguruPreview';
import Footer from '../../../components/Footer/Footer';

const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${() => (isMobile ? '56px' : '-42px')};
  padding-top: ${(props) => (props.visible ? '20px' : '120px')};
  opacity: ${(props) => (props.visible ? '1' : '0')};
  width: 100%;
  transition: 1s;
  text-align: center;
  font-size: 20px;
  font-family: miller-display, serif;
  font-weight: 400;
  line-height: 20px;
`;

const RecentWork = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #223742;
  margin-bottom: 54px;
  width: 100%;
`;

const Hr = styled.div`
  height: 1px;
  width: 72px;
  background: #861657;
  margin-top: 6px;
`;

const RecentWorkContainer = (props) => {
  const [desktop, setDesktop] = useState();

  const checkDesktop = () => {
    window.matchMedia('(max-width: 768px)').matches
      ? setDesktop(false)
      : setDesktop(true);
  };

  useEffect(() => {
    checkDesktop();
  });

  useEffect(() => {
    window.addEventListener('resize', checkDesktop);
    return () => {
      window.removeEventListener('resize', checkDesktop);
    };
  });

  return (
    <PreviewContainer id="work" visible={props.visible}>
      <RecentWork>
        Recent Work
        <Hr />
      </RecentWork>
      <AbcPreview desktop={desktop} />
      <TasklyPreview desktop={desktop} />
      <KaenguruPreview desktop={desktop} />
      <Footer />
    </PreviewContainer>
  );
};

export default RecentWorkContainer;
